import * as React from 'react';
import { observer } from 'mobx-react-lite';
import { GenericSelect } from '../../components';
import { InputModelWithSource } from '../../models';
import { InputWithSource } from '../../componentTypes';

const InsuredPeriodEndInput: InputWithSource = ({ input }) => <GenericSelect label={input.name} input={input} />;

InsuredPeriodEndInput.meta = {
    inputType: InputModelWithSource.name
};

export default observer(InsuredPeriodEndInput);
